import { Controller } from '@hotwired/stimulus'

// Reveals the work-in-progress statement the moment its checkbox is ticked on
// the termination document's Financial Values form. The checkbox autosaves like
// every other field, but that response only re-renders the letter preview — so
// the reveal can't wait for the round trip.
//
// Visibility only: the statement is deliberately not an HTML `required` field.
// The checkbox submits on change, and a required-but-empty input makes the
// browser refuse that submit without saying why — so ticking or unticking the
// box would silently fail to save. Whether the statement is present is enforced
// server-side instead (values_complete? gates sending and warns on save).
export default class extends Controller {
  static targets = ['checkbox', 'statement']

  connect() {
    this.refresh()
  }

  refresh() {
    this.statementTarget.classList.toggle('d-none', !this.checkboxTarget.checked)
  }
}
